<template>
      <div no-body class="lku-charges"> 
      <b-row v-if="lkuLoading" class="justify-content-center mb-2"><span style="color:blue;">Loading data ...</span></b-row>
      <b-row v-else>
            <b-col cols="7">
              <b-input-group >
                  <b-input-group-append><label class="pt-2 pr-2">Filter</label></b-input-group-append>
                  <b-form-input v-model="tblData.namabank" placeholder="Bank/Cash Acc. Name" @keyup.13.native="refresh()" style="width:40% !important"></b-form-input>
                  <b-form-input v-model="tblData.kode" placeholder="Bank/Cash Acc. Code" @keyup.13.native="refresh()" class="ml-1"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col cols="5">
              <b-input-group >
                  <b-input-group-append><label class="pt-2 pr-2">Active</label></b-input-group-append>
                  <b-form-select v-model="tblData.aktif" :plain="true" :options="dataList.YesNoAll"></b-form-select>                          
                  <b-input-group-append>
                      <b-button class="btn btn-success ml-3" @click="refresh()" > <i class="fa fa-refresh"></i> Apply Filter</b-button>
                  </b-input-group-append>
                  <b-input-group-append>
                    <b-button class="btn btn-secondary ml-1" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear </b-button>
                  </b-input-group-append>
              </b-input-group>
            </b-col>
      </b-row>
        <b-table
          class="mb-0"
          ref="tblBankcash" style="font-size:smaller;" 
          responsive small striped hover
          :items="tblData.items"
          :fields="fields"
          :per-page="tblData.limit"
          :sort-by.sync="tblData.sortBy"
          :sort-desc.sync="tblData.sortDesc"
          :key="updatetable" 
          @row-clicked="selectItem"
        >
        <template v-slot:cell(kode)="data">
            <span v-if="(data.item.isbank==1)">{{data.item.kode}}</span>
            <span v-else style="color:green;">{{data.item.kode}}</span>
        </template>  
        <template v-slot:cell(namabank)="data">
            <span v-if="(data.item.isbank==1)">{{data.item.namabank}}</span>
            <span v-else style="color:green;">{{data.item.namabank}}</span>
        </template>  
        <template v-slot:cell(matauang)="data">
            <span v-if="(data.item.isbank==1)">{{data.item.matauang}}</span>
            <span v-else style="color:green;">{{data.item.matauang}}</span>
        </template>  
        <template v-slot:cell(namabank2)="data">
            <span v-if="(data.item.isbank==1)">{{data.item.namabank2}}</span>
        </template>  
        </b-table>
      <b-row>
        <b-col cols="4">
          <div class="pt-2">
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total | numFormat}} entries
        </div>        
        </b-col>
        <b-col cols="3">            
            <b-row class="ml-2 mt-2">
              <span class="pt-1 pr-2">Limit per page</span>
              <input type="number" style="width:80px;" v-model="tblData.limit"/>
            </b-row>
        </b-col>
        <b-col cols="5">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
  </div>
</template>

<script>
import bankcashacc from "../../apis/bankcashacc";
import dropdown from "../../data/dropdown";

export default {
  data() {
    return {
      fields: [
        {
          key: "kode",
          thStyle: "width:100px",
          label: "Account Code",
          sortable: true
        },
        {
          key: "namabank",
          label: "Account Name",
          sortable: true
        },
        {
          key: "matauang",
          thStyle: "width:40px",
          label: "Rp,$,¥",
          sortable: true
        },
        {
          key: "nomorrek",
          label: "Nomor Rekening",
          sortable: true
        },
        {
          key: "cabang",
          label: "Cabang",
          sortable: true
        },
        {
          key: "kodeacc",
          label: "GL Account",
          sortable: true
        },
        {
          key: "aktif",
          label: "Active",
          thStyle: "width:40px",
          sortable: true
        },
      ],
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: 'namabank',
        sortDesc: false,aktif:'1',isbank:''
      },
      dataList: {
        YesNo: dropdown.YesNo,
        YesNoAll: dropdown.YesNoAll,
        BankOrCash: [{value: '0', text: 'CASH'}, {value: '1', text: 'BANK'}],
        BankOrCashAll: [{value: '', text: '-ALL-'},{value: '0', text: 'CASH'}, {value: '1', text: 'BANK'}],
      },      
      lkuLoading:false
    };
  },
  computed: {
    showingLabel() {
      const { tblData } = this;
      const { page, limit, total } = tblData;

      const val1 = (page - 1) * limit + 1;
      const val2 = page * limit < total ? page * limit : total;
      return `Showing ${val1} to ${val2} of ${total} entries`;
    },
  },
  props: ["isbank","aktif","formdata"],
  created: async function() {
      this.$emit('update:isbank', '');
      this.tblData.aktif=this.aktif || '';
      if (this.formdata.items)
      {
          for (var key in this.formdata) {
              this.tblData[key] = this.formdata[key];
          }
      } else {
        this.data();
      }
  },  
  watch: {
    "tblData.page": function(newval) {
      this.tblData.page=newval;
      this.refresh();
    },   
    "tblData.limit": function(newval) {
      this.data();
    },   
    "tblData.sortBy": function(newval) {
      this.data();
    },   
    "tblData.sortDesc": function(newval) {
      this.data();
    },   
  },
  methods: {
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.tblData.isbank=this.isbank;
      this.lkuLoading=true;
      const list = await bankcashacc.list(this.tblData);      
      this.lkuLoading=false;
      this.tblData.items = list;      
      this.updatetable=!this.updatetable;
    },
    selectItem(item,index) {
      // 'item' will be the row data from items
      // `index` will be the visible row number (available in the v-model 'shownItems')
      this.tblData.selected=item;
      this.$emit("click", this.tblData);
    },
    clearFilter() {
        this.tblData.kode='';
        this.tblData.namabank= '';
        this.tblDataaktif='';
        // this.refresh();
    },    
    keymonitor: function(event) {
        // console.log(event.key);
       if(event.key == "Enter")
       {
        //  console.log('the id of the input was:' + event.currentTarget.id);
        this.data();
        this.$refs.tblBankcash.refresh();
       }
    },    
    refresh() {
        this.data();
      this.$refs.tblBankcash.refresh();
    }
  }
};
</script>
